// extracted by mini-css-extract-plugin
export default {"form__group":"login_form__group__GbxKj","form__input":"login_form__input__JQRH1","form__checkbox":"login_form__checkbox__sHbFK","button__wrapper":"login_button__wrapper__xIn6a"};